import { projectApi } from "@/api/projectApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import SettingsIcon from "@mui/icons-material/Settings";
import { Avatar, Box, Container, Tab, Tabs, Typography } from "@mui/material";
import { Outlet, Link as RouterLink, useMatch, useNavigate, useParams } from "react-router-dom";

export default function ProjectViewerLayout() {
    const { projectId } = useParams();
    const tabUrl = (tab) => `/projects/${projectId}/${tab}`;
    const navigate = useNavigate();
    const matchPath = useMatch("/projects/:projectId/:tab/*");
    const currentTab = matchPath?.params.tab ?? "info";

    // TODO: change api to /projects/{id}/info
    const projectResult = projectApi.endpoints.getProjectById.useQuery(projectId);
    const project = projectResult.data?.data;
    const pageLoading = projectResult.isLoading;

    // HOC
    if (pageLoading) {
        return <>loading...</>;
    }

    return (
        <>
            <Container>
                <Breadcrumbs items={[{ label: "Projects", to: "/workspace/projects" }, { label: `#${projectId}` }]} />
            </Container>

            <Container>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ marginRight: 2 }}>
                        <Avatar variant="rounded" color="secondary" sizes="54" sx={{ width: 54, height: 54 }}>
                            {"#" + projectId}
                        </Avatar>
                    </Box>
                    <Box>
                        <Typography variant="h1" fontSize="0.9em" color="grey">
                            Projects
                        </Typography>
                        <Typography variant="h2" fontSize="1.2em" fontWeight="bold" gutterBottom>
                            {project?.name}
                        </Typography>
                        <Typography variant="h2" fontSize="1em" gutterBottom>
                            {project?.name_en}
                        </Typography>
                        <Typography>{project?.lifecycle_status?.name_display}</Typography>
                    </Box>
                </Box>

                <Tabs value={currentTab} sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tab component={RouterLink} label="Information" value="info" to={tabUrl("info")} />
                    {/**
                    <Tab
                        component={RouterLink}
                        label="Timeline"
                        value="timelines"
                        to={tabUrl("timelines")}
                        disabled={true}
                    />
                    <Tab component={RouterLink} label="Budget" value="budgets" to={tabUrl("budgets")} disabled={true} />
                    */}
                    <Tab component={RouterLink} label="KPI" value="kpis" to={tabUrl("kpis")} disabled={true} />
                    <Tab
                        component={RouterLink}
                        label={
                            <Box display="inline-flex" alignItems="center">
                                <SettingsIcon fontSize="small" />
                                <span> Setting</span>
                            </Box>
                        }
                        value="settings"
                        to={tabUrl("settings")}
                    />
                </Tabs>
            </Container>

            {/** content */}
            <Outlet context={{ project }} />
        </>
    );
}
